import type { BaseSpace, BaseSpaceScale } from '../types/BaseTheme';

const scale: Required<BaseSpaceScale> = {
  0: 0,
  1: 4,
  2: 8,
  3: 16,
  4: 32,
  5: 64,
  6: 128,
  7: 256,
  8: 512,
};

const space: BaseSpace = {
  ...scale,
  // Inbetweens, use sparingly
  '1,5': 6,
  '2,5': 12,
  '3,5': 24,
  '4,5': 48,
  '5,5': 96,
};

export default space;
